export default __webpack_public_path__ + "static/media/good_score_icon.c105c6e0.svg";